import React, { useEffect, useState } from 'react';
import { TreeSelect, Divider, Checkbox } from 'antd';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const PLACEHOLDER_SELECT = 'Please select';

const MultiSelect = ({
  options,
  values,
  onChange,
  isDisabled,
  className,
  size
}) => {
  const [indeterminate, setIndeterminate] = useState(false);
  const [checkAll, setCheckAll] = useState(false);

  const handleSelectAll = (list) => {
    setIndeterminate(list?.length && list.length < options.length);
    setCheckAll(list?.length === options?.length);
  };

  useEffect(() => {
    handleSelectAll(values);
  }, [values, options]);

  const handleChange = (list) => {
    handleSelectAll(list);
    onChange(list);
  };

  const onCheckAllChange = (e) => {
    setIndeterminate(false);
    setCheckAll(e.target.checked);
    onChange(e.target.checked ? options?.map((item) => item.value) : []);
  };

  return (
    <TreeSelect
      className={className}
      allowClear
      autoClearSearchValue={false}
      maxTagCount={0}
      treeCheckable
      showCheckedStrategy={TreeSelect.SHOW_CHILD}
      treeData={options}
      value={values}
      size={size}
      showArrow
      filterTreeNode={(inputValue, option) =>
        option.title
          ?.toString()
          .toLowerCase()
          .includes(inputValue.toLowerCase())
      }
      treeNodeFilterProp="title"
      dropdownRender={(dropdownValues) => (
        <>
          {dropdownValues.props?.searchValue?.length == 0 && (
            <div>
              <StyledCheckbod
                indeterminate={indeterminate}
                onChange={onCheckAllChange}
                checked={checkAll}>
                Select All
              </StyledCheckbod>
              <Divider style={{ marginTop: 4, marginBottom: 4 }} />
            </div>
          )}
          <div style={{ marginLeft: -16 }}>{dropdownValues}</div>
        </>
      )}
      maxTagPlaceholder={values?.length + ' selected'}
      placeholder={PLACEHOLDER_SELECT}
      onChange={handleChange}
      disabled={isDisabled}
    />
  );
};

const StyledCheckbod = styled(Checkbox)`
  margin-left: 8px;
  width: 100%;

  .ant-checkbox + span {
    width: 100%;
    padding-left: 4px;
    margin-left: 8px;
    margin-right: 8px;

    &:hover {
      background-color: #f5f5f5;
    }
  }
`;

MultiSelect.propTypes = {
  options: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string,
      value: PropTypes.number
    })
  ),
  values: PropTypes.array,
  onChange: PropTypes.func.isRequired,
  isDisabled: PropTypes.bool,
  className: PropTypes.string,
  size: PropTypes.string
};

export default MultiSelect;
